// extracted by mini-css-extract-plugin
module.exports = {"plans":"Plans_plans__3aK9D"};